import { memo, useRef } from 'react';
import { Box, Heading, Link, SimpleGrid, Text, VStack } from '@chakra-ui/react';

import { useReactToPrint } from 'react-to-print';
import { getSessionFormData } from '../../utils';
import { useDonationInfo } from '../../hooks';
import { DoubleTheDonationSearch } from '../doubleDonation';

export const Success = memo(() => {
  const printRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => printRef.current || null,
    pageStyle: `@page { padding: 20px; }`,
  });

  const { data } = useDonationInfo();
  const transaction = data?.transaction;

  const {
    firstName,
    donationAmount,
    donationOtherAmount,
    donorEmail,
    paymentSchedule,
  } = getSessionFormData() || { donationOtherAmount: 0 };

  return (
    <>
      <VStack spacing={8} align="left" mb={12} ref={printRef}>
        <Heading as="h1" fontWeight="regular">
          Thank you, {firstName}!
        </Heading>

        <Text>
          Your gift will help ensure that families never receive a bill from St.
          Jude for anything, because all they should worry about is helping
          their child live.
        </Text>

        <SimpleGrid columns={[null, null, 2]} spacingY={[8, 8, 0]}>
          <Box>
            <Text>Donation Amount</Text>
            <Text fontSize="3xl">
              {Number(transaction?.amount) ||
                `$${
                  donationOtherAmount > 0 ? donationOtherAmount : donationAmount
                }`}
            </Text>
          </Box>
        </SimpleGrid>

        <Box>
          <Text>Donation Type</Text>
          <Text fontSize="3xl">{paymentSchedule}</Text>
        </Box>

        <Box>
          <Text>We'll send a copy of your receipt to</Text>
          <Text fontSize="3xl">{donorEmail}</Text>
        </Box>
      </VStack>

      <VStack spacing={12} align="left">
        <Text>
          <Link as="a" onClick={handlePrint}>
            Print your donation receipt
          </Link>
        </Text>

        <Box>
          <DoubleTheDonationSearch hasCompanyInfo />
        </Box>

        <Box>
          <Text mb={4}>
            Any questions? Contact us at (800) 822-6344 or{' '}
            <Link as="a" href="mailto:donors@stjude.org">
              donors@stjude.org
            </Link>
          </Text>

          {
            // TODO: Survey on hold. Awaiting clarification from DEX
          }
          {/* <Text>
            Please take a moment to{' '}
            <Link
              as="a"
              href="https://feedback.stjude.org/jfe/form/SV_d4lm9W77YpivnIV"
            >
              let us know how your donations experience went today.
            </Link>
          </Text> */}
        </Box>
      </VStack>
    </>
  );
});
